import barba from '@barba/core';
import { gsap } from "gsap";

export const pencil = () => { 

    const canvas = document.getElementById('canvas');
    const touchCanvas = document.getElementById('touch-canvas');
    // const touchSurface = document.getElementById('touchSurface');
    const ctx = canvas.getContext('2d');
    const canvasOffsetX = canvas.offsetLeft;
    const canvasOffsetY = canvas.offsetTop;
    canvas.width = window.innerWidth - canvasOffsetX;
    canvas.height = window.innerHeight - canvasOffsetY;

    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    var isMouseDown = false;
    var isPainting = true;
    var points = [];

    var memCanvas;
    var memCtx;
    memCanvas = document.createElement('canvas');
    var canW = window.innerWidth - canvasOffsetX;
    var canH = window.innerHeight - canvasOffsetY;
    memCanvas.width = canW;
    memCanvas.height = canH;
    memCtx = memCanvas.getContext('2d');

    var allLinks = document.querySelectorAll('a');
    var linkHover = false;

    var timer;
    var isMobile = false;

    var favicon = document.querySelectorAll("link[rel~='icon']");

    var colors = [
        'red', 
        'green', 
        'blue', 
        'orange', 
        'yellow'
    ];

    var newColorIndex;
    var colorIndex = Math.floor(Math.random() * colors.length);
    var curColor = colors[colorIndex];

    var isSmallDevice = window.matchMedia("only screen and (max-width: 760px)");
    var isTouch = !!("undefined" != typeof document.documentElement.ontouchstart);

    var isScrolling = false;
    var scrollTimer = null;

    window.addEventListener('scroll', function() {
    isScrolling = true;

    if(scrollTimer !== null) {
    clearTimeout(scrollTimer);        
        }
        scrollTimer = setTimeout(function() {
              isScrolling = false;
        }, 150);
    }, false);

    barba.hooks.enter((data) => {
        allLinks = document.querySelectorAll('a');
    });

    function checkDevice() {

        if(isSmallDevice.matches && isTouch) {
            // is mobile device
            isMobile = true;
        } else {
            // is not a mobile device
            isMobile = false;
        }
    }
    checkDevice();

    function updateFavicon(colorIndex) {
        for ( var i = 0; i < favicon.length; ++i) {
            favicon[i].setAttribute("href", templateUrl + "/imgs/favicon/favicon-0" + (colorIndex + 1) +  ".png");
        }
    }

    function getNewColorIndex(oldColorIndex) {
        newColorIndex = Math.floor(Math.random() * colors.length);
        while (newColorIndex === oldColorIndex) {
            newColorIndex = Math.floor(Math.random() * colors.length);
        }
        return newColorIndex;
    } 

    function ctx_stuff(){
        ctx.lineWidth = 50;
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
    }

    const checkMouseMove = () => {
        clearTimeout(timer);
        timer=setTimeout(function(){

            colorIndex = getNewColorIndex(colorIndex);
            curColor = colors[colorIndex];

            points = [];
            memCtx.clearRect(0, 0, canW, canH);
            memCtx.drawImage(canvas, 0, 0);
            ctx.clearRect(0, 0, canW, canH);

            // put back the saved content
            ctx.drawImage(memCanvas, 0, 0);

        },100);
    }

    function handleMouseMove(e) {

        if(isPainting){
            memCtx.clearRect(0, 0, canW, canH); 
            ctx.clearRect(0, 0, canW, canH);       

            // put back the saved content
                var m = getMouse(e, canvas);
                points.push({
                    x: m.x,
                    y: m.y
                });
                ctx.beginPath();
                ctx.globalCompositeOperation = "source-over";
                drawPoints(ctx, points);

                updateFavicon(colorIndex);
                checkMouseMove();
        }
    }

    function checkIfLinkHover(){
        if (allLinks && !isMobile){
            for ( var i = 0; i < allLinks.length; ++i) {
                if(allLinks[i].matches(':hover') && !canvas.classList.contains('blur')){
                    canvas.classList.remove('blur');
                    canvas.classList.add('blur');
                }
                else{
                    allLinks[i].addEventListener("mouseenter", (event) => {
                        canvas.classList.remove('blur');
                        canvas.classList.add('blur');
                    });
                    allLinks[i].addEventListener("mouseleave", (event) => {
                        canvas.classList.remove('blur');
                    });
                }
            }
        }
    }

    function drawPoints(ctx, points) {

        if (points.length < 6) {
            var b = points[0];

            ctx.beginPath(), 
                ctx.arc(b.x, b.y, ctx.lineWidth / 2, 0, Math.PI * 2, !0),
                ctx.closePath(),
                ctx.fillStyle = curColor,
                ctx.fill();
            return;
        }
        
        ctx_stuff();
        ctx.beginPath(), ctx.moveTo(points[0].x, points[0].y);
        // draw a bunch of quadratics, using the average of two points as the control point
        for (var i = 1; i < points.length - 2; i++) {
            var c = (points[i].x + points[i + 1].x) / 2,
                    d = (points[i].y + points[i + 1].y) / 2;
            ctx.quadraticCurveTo(points[i].x, points[i].y, c, d);
        }

        ctx.quadraticCurveTo(
            points[i].x,
            points[i].y,
            points[i + 1].x,
            points[i + 1].y),
            ctx.strokeStyle = curColor,
            ctx.stroke();
    }

    function getMouse(e, canvas) {
        var element = canvas, 
            offsetX = 0, 
            offsetY = 0,
            scrollY = window.scrollY,
            scrollX = window.scrollX,
            mx, 
            my;

        // Compute the total offset. It's possible to cache this if you want
        if (element.offsetParent !== undefined) {
            do {
                offsetX += element.offsetLeft;
                offsetY += element.offsetTop;
            } while ((element == element.offsetParent));
        }

        if(isMobile && isScrolling) {
            mx = e.changedTouches[0].pageX - offsetX - scrollX;
            my = e.changedTouches[0].pageY - offsetY - scrollY;
        } else {
            mx = e.pageX - offsetX - scrollX;
            my = e.pageY - offsetY - scrollY;
        }

        // We return a simple javascript object with x and y defined
        return {x: mx, y: my};
    }

    window.addEventListener('mousemove', (e) => {
        checkIfLinkHover();
        handleMouseMove(e);
    });
    window.addEventListener('touchmove', (e) => {
        handleMouseMove(e);
    });

}
